module.exports = __webpack_public_path__ + "assets/img/chicken_wing.7b118d6b.png";